module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/high_protein--xxl@2x-b1e4e0d6f3b918bb6ff60a9df29c8301.png";